import { Directive } from '@angular/core';

/** Классы как у реестра v2 (см. styles/rpt-registry-v2.scss) — оборачивает «сырой» p-table. */
@Directive({
  standalone: true,
  selector: '[crmRptRegistryTableChrome]',
  host: {
    class: 'rpt-standard-table-wrap rpt-registry-v2-skin'
  }
})
export class RptRegistryTableChromeDirective {}
